import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/station/[id]/client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/station/[id]/station.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/station/[id]/freqs/freqs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/alarm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/favorite/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/rating/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/buttons/sleep/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/icon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/play/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/playlist/desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/playlist/mobile.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/station/logo/logo.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/stations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/survey/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/tags/tags.module.scss");
